import React, { useRef } from 'react';

import { SiteNav } from '../../components/SiteNav/SiteNav';
import { type NavLink } from '../../components/SiteNav/types';
import { SiteFooter } from '../../components/SiteFooter/SiteFooter';

import birdSvg from '../../components/brand/faves-bird.svg';
import { Countdown } from './Countdown';
import { useDvdBounce } from './useDvdBounce';

// 2026-06-02 00:00 Pacific Time (PDT, UTC-7): Date.UTC(2026, 5, 2, 7, 0, 0)
const COUNTDOWN_TARGET_MS = 1780383600000;

type SplashProps = {
    csrfToken: string;
    redesignEnabled: boolean
};

const LEGACY_LINKS: ReadonlyArray<NavLink> = [
    { label: 'Apply', href: 'https://faves.xyz/apply/64eb8975-a4e5-4f29-bcb7-1d84e62df971', group: 'account' },
    { label: 'Athlete portal', href: '/portal/login', group: 'account' },
];

const REDESIGN_LINKS: ReadonlyArray<NavLink> = [
    { label: 'For athletes', href: '/for-athletes', group: 'primary' },
    { label: 'For brands', href: '/for-brands', group: 'primary' },
    { label: 'Apply', href: 'https://faves.xyz/apply/64eb8975-a4e5-4f29-bcb7-1d84e62df971', group: 'account' },
    { label: 'Athlete portal', href: '/portal/login', group: 'account' },
];

export function Splash({ csrfToken, redesignEnabled }: SplashProps) {
    const heroRef = useRef<HTMLDivElement | null>(null);
    const heroImageRef = useRef<HTMLImageElement | null>(null);
    const countdownRef = useRef<HTMLDivElement | null>(null);
    useDvdBounce(heroRef, heroImageRef, countdownRef);

    return (
        <div className="splash">
            <div className="splash__stage">
                <SiteNav links={redesignEnabled ? REDESIGN_LINKS : LEGACY_LINKS}/>

                <div className="splash__hero" ref={heroRef}>
                    <img ref={heroImageRef} src={birdSvg} alt="" className="splash__hero-graphic" />
                    <Countdown ref={countdownRef} targetMs={COUNTDOWN_TARGET_MS} />
                </div>
            </div>

            <SiteFooter csrfToken={csrfToken} redesignEnabled={redesignEnabled} />
        </div>
    );
}
